import React from 'react';
import { Box, Button, Card, CardBody, Table, Tbody, Tr, Th } from '@chakra-ui/react';
import { ViewIcon } from '@chakra-ui/icons';

import { Order } from '../../store/page/types';
import { UserOrdersDetails, User, UserOrder } from '../../store/user/types';
import NoContentPage from '../../pages/noContent/NoContentPage';
import OrderRow from '../page/OrderRow';

interface ViewUserOrdersProps {
  userView: string;
  userOrders: UserOrder[];
  userOrdersDetails: UserOrdersDetails;
  user: User | null;
  fetchUserOrders: (userId: string, more: boolean) => void;
}

const ViewUserOrders: React.FC<ViewUserOrdersProps> = ({ userView, userOrders, user, userOrdersDetails, fetchUserOrders }) => {
  if (userView!=='orders') {
    return null;
  }

  const renderMoreButton = () => {
    const { currentPage, totalPages } = userOrdersDetails;
    if (currentPage && totalPages && currentPage < totalPages) {
      return (
        <Box display="flex" justifyContent="center" mt={2}>
          <Button size='xs' leftIcon={<ViewIcon />} onClick={
            () => {
              if (user && user._id) {
                fetchUserOrders(user._id, true)
              }
            }
            }>More</Button>
        </Box>
      )
    }
    return null;
  }

  return (
    <Box paddingTop={5} paddingBottom={5}>
      <Card borderRadius={20}>
        <CardBody>
          <Table>
            <Tbody>
              <Tr>
                <Th>Order #</Th>
                <Th textAlign={'right'}>Total</Th>
                <Th textAlign={'right'}>Delivered/Target</Th>
                <Th>Status</Th>
              </Tr>
              {userOrders.map((item: UserOrder, index: number) => (
                <OrderRow order={item} key={index} />
              ))}
            </Tbody>
          </Table>   
          {renderMoreButton()}   
          { !userOrders.length && (
            <NoContentPage noContentText='No Orders Found' />
          )}              
        </CardBody>
      </Card>  
    </Box>      
  );
}

export default ViewUserOrders;
